import React from "react"
import "./Home.css"
import hero from "./portfolio_img.jpg"

import { Typewriter } from "react-simple-typewriter"

const Home = () => {
  return (
    <>
      <section className='hero' id='about'>
        <div className='container f_flex top'>
          <div className='left top'>
            <h3>WELCOME TO MY WORLD</h3>
            <h1>
              Hi, I’m <span>Rugved Gadakh</span>
            </h1>
            <h2>
              a
              <span>
                <Typewriter words={[" Professional Coder.", " Developer."]} loop cursor cursorStyle='|' typeSpeed={70} deleteSpeed={50} delaySpeed={1000} />
              </span>
            </h2>

            <p>Hello I'm Rugved.
              I'm currently in third year of my Information Technology Engineering . A workaholic personality currently working on my problem solving skills to get a good hand in competitive programming and DSA. <br/>
              A front end web developer.
              Exploring and working on Artificial intelligence and Machine learning to contribute to future world of AI.</p>

            <div className='hero_btn d_flex'>
              <div className='col_1'>
                <h4>FIND WITH ME</h4>
                <div className='button'>
                  <a href="https://www.facebook.com/profile.php?id=100077268612287">
                  <button className='btn_shadow'>
                    <i className='fab fa-facebook-f'></i>
                  </button>
                  </a>
                  
                  <a href="https://www.instagram.com/rugvedgadakh/"><button className='btn_shadow'>
                    <i className='fab fa-instagram'></i>
                  </button></a>
                  
                  <a href="https://www.linkedin.com/in/rugved-gadakh-824bb6232/"><button className='btn_shadow'>
                    <i className='fab fa-linkedin-in'></i>
                  </button></a>
                  
                </div>
              </div>
            </div>
          </div>
          <div className='right'>
            <div className='right_img'>
              <img src={hero} alt='profile_img' />
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default Home